export type SavedConsent = IConsent | null;

export const CONSENT_TYPE_CATEGORY = "category";
export const CONSENT_TYPE_GRANULAR = "granular";
export type ConsentType = |
  typeof CONSENT_TYPE_CATEGORY |
  typeof CONSENT_TYPE_GRANULAR;

export interface IConsent {
  [key: string]: boolean | undefined;
}
export interface IGranularMetadata {
  [key: string]: IServiceMeta;
}

export interface IServiceMeta {
  name: string;
  unique_service_uuid: string;
  categories: CookieCategory[];
}

export type CookieCategory =
  | "necessary"
  | "performance"
  | "functional"
  | "advertising";

export type ConsentTimestamp = number;

export type SavedConsentTimestamp = ConsentTimestamp | null;

export const CONSENT_POLICY_CATEGORY_OPTIN = 1;
export const CONSENT_POLICY_GRANULAR_OPTIN = 2;
export type ConsentPolicy = |
  typeof CONSENT_POLICY_CATEGORY_OPTIN |
  typeof CONSENT_POLICY_GRANULAR_OPTIN;


export const CONSENT_ACTION_DENY = "deny";
export const CONSENT_ACTION_STORE = "store";
export const CONSENT_ACTION_UPDATE = "update";
export const CONSENT_ACTION_WITHDRAW = "withdraw";
export const CONSENT_ACTION_RESET = "reset";

export type ConsentAction = |
  typeof CONSENT_ACTION_DENY |
  typeof CONSENT_ACTION_STORE |
  typeof CONSENT_ACTION_UPDATE |
  typeof CONSENT_ACTION_WITHDRAW |
  typeof CONSENT_ACTION_RESET;
